// A plain DOM `Event` and a React `SyntheticEvent` are structurally
// unrelated types (`SyntheticEvent` doesn't extend `Event`), but every
// caller here only ever reads `.target` off either kind — accept the
// minimal shape both satisfy rather than tying this to one or the other.
type TargetedEvent = { target: EventTarget | null };

export function buttonTarget(e: TargetedEvent): HTMLButtonElement {
  if (e.target instanceof HTMLButtonElement) {
    return e.target;
  } else {
    throw new Error(
      `Expected Event target to be HTMLButtonElement but found ${typeof e.target}`
    );
  }
}

export function inputTarget(e: TargetedEvent): HTMLInputElement {
  if (e.target instanceof HTMLInputElement) {
    return e.target;
  } else {
    throw new Error(
      `Expected Event target to be HTMLInputElement but found ${typeof e.target}`
    );
  }
}

export function textareaTarget(e: TargetedEvent): HTMLTextAreaElement {
  if (e.target instanceof HTMLTextAreaElement) {
    return e.target;
  } else {
    throw new Error(
      `Expected Event target to be HTMLTextAreaElement but found ${typeof e.target}`
    );
  }
}

export function selectTarget(e: TargetedEvent): HTMLSelectElement {
  if (e.target instanceof HTMLSelectElement) {
    return e.target;
  } else {
    throw new Error(
      `Expected Event target to be HTMLSelectElement but found ${typeof e.target}`
    );
  }
}

export const eventTargetValue = (event: unknown): string => {
  if (
    event &&
    typeof event === 'object' &&
    'target' in event &&
    event.target &&
    typeof event.target === 'object' &&
    'value' in event.target &&
    typeof event.target.value === 'string'
  ) {
    return event.target.value;
  }
  throw new Error(
    'Expected event object with `event.target.value` set to a string'
  );
};
